import offTime from './offTime';
import group from './group';
import tour from './tour';
import assignment from './assignment';
import daysOffRequest from './daysOffRequest';


const contextMenuArrays = {
  offTime: Object.values(offTime),
  group: Object.values(group),
  tour: Object.values(tour),
  assignment: Object.values(assignment),
  daysOffRequest: Object.values(daysOffRequest)
};

export default contextMenuArrays;



// WEBPACK FOOTER //
// ./src/Components/Schedule/utils/live-schedules/context-menu-arrays/index.js